'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _customPropTypes = require('../utils/custom-prop-types');

var _select = require('./select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
|-------------------------------------------------------------------------------
| Select Controller
|-------------------------------------------------------------------------------
|
| The following component consumes the state and actions from a parent Select
| Container, and gives it to it's child as props.
|
| It can be used to wrap any kind of Select component:
|
|  - Input
|  - Menu
|
*/

/* eslint-disable react/prop-types */
function selectController(WrappedComponent) {
  var _class, _temp;

  var name = 'selectCtrl(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')';
  var SelectController = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SelectController, _Component);

    function SelectController() {
      (0, _classCallCheck3.default)(this, SelectController);
      return (0, _possibleConstructorReturn3.default)(this, (SelectController.__proto__ || (0, _getPrototypeOf2.default)(SelectController)).apply(this, arguments));
    }

    (0, _createClass3.default)(SelectController, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (!this.context[_select.SELECT_MODEL]) {
          console.warn('"' + name + '" was used without a parent Select component.\nAdd the "' + '<Select />' + '" component anywhere above "' + name + '".');
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, { select: this.context[_select.SELECT_MODEL] }));
      }
    }]);
    return SelectController;
  }(_react.Component), _class.contextTypes = (0, _defineProperty3.default)({}, _select.SELECT_MODEL, _customPropTypes.SelectModelPropType), _temp);

  // NOTE: We go ahead and hoist prop types, so tools like Storybook work nicely.

  (0, _hoistNonReactStatics2.default)(SelectController, WrappedComponent);
  process.env.NODE_ENV !== "production" ? SelectController.propTypes = WrappedComponent.propTypes : void 0;
  SelectController.defaultProps = WrappedComponent.defaultProps;
  SelectController.displayName = name;

  return SelectController;
}

exports.default = selectController;